import { Component } from '@angular/core';

@Component({
  selector: 'icon-send',
  standalone: true,
  template: `
    <svg xmlns="http://www.w3.org/2000/svg" width="14" height="17" viewBox="0 0 14 17" fill="none">
      <path fill-rule="evenodd" clip-rule="evenodd" d="M6.38128 0.792893C6.72299 0.402369 7.27701 0.402369 7.61872 0.792893L13.7437 7.79289C14.0854 8.18342 14.0854 8.81658 13.7437 9.20711C13.402 9.59763 12.848 9.59763 12.5063 9.20711L7.875 3.91421V15.5C7.875 16.0523 7.48325 16.5 7 16.5C6.51675 16.5 6.125 16.0523 6.125 15.5V3.91421L1.49372 9.20711C1.15201 9.59763 0.59799 9.59763 0.256282 9.20711C-0.0854272 8.81658 -0.0854272 8.18342 0.256282 7.79289L6.38128 0.792893Z" fill="#F8F9FA"/>
    </svg>
  `,
  styles: [
   `svg {
      path {
        fill: #fff!important;
      }
    }`
  ]
})
export class SendIconComponent {

}
